<template>
    <footer class="footer">
        <div class="ambienteAtual">{{ ambienteAtual }}</div>
        <!-- <span>EGIS Brasil</span> -->
        <a href="https://www.egis-brasil.com.br/" target="_blank">
        <img src="@/assets/images/egis_logo.png" alt="EGIS Brasil" class="logo"></a>
    </footer>
</template>

<script>
import ambiente from '../../ambiente.json'
export default {
    name: "Footer",
    data: function(){
        return {
            ambienteAtual: ""
        }
    },
    mounted(){
        this.ambienteAtual = ambiente.ambiente;
    }
}



</script>

<style>
    .footer .ambienteAtual{
        margin-left: 10px;
        flex-basis: 100%;
        justify-self: flex-end;
        justify-content: flex-start;
    }
    .footer {
        grid-area: footer;
        background-color: #ffffff;
        color: #333;
        border-top: 1px solid #bbb;

        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding-right: 10px;
    }

    .footer .logo{
        max-height: 48px;
    }
</style>
